module.exports = __webpack_public_path__ + "img/submit_btn_bg.599c446b.png";